<template>
  <b-card no-body class="p-3">
    <template #header>
      <b-card-sub-title
        class="my-0"
        v-bind:class="{
          'card-subtitle-doom-yoga': client_name == 'DY',
          'card-subtitle-irish-date': client_name == 'MID',
        }"
        >Location</b-card-sub-title
      >
    </template>

    <b-card-body class="pt-0">
      <b-row v-if="invalid_location">
        <b-col>
          <p 
              :class="{
                'error_validation_message_p_dy mx-0': client_name == 'DY',
                error_validation_message_p_mid: client_name == 'MID',
              }">Please select location</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- <b-input-group>
            <b-input-group-prepend> sad </b-input-group-prepend> -->

          <b-input-group
            class="w-100"
            id="inputGroupLocation"
            :class="{
              'form-group-select2-doomyoga': client_name == 'DY',
              'form-group-select2-mid': client_name == 'MID',
            }"
          >
            <b-input-group-prepend class="p-2">
              <img
                v-if="client_name == 'DY'"
                class="sessionIconImg"
                src="@/assets/images/doom-yoga/location-icon.png"
                alt="location"
                width="20px"
                height="25px"
              />
              <img
                v-if="client_name == 'MID'"
                class="sessionIconImg"
                src="@/assets/images/my-irish-date/location-icon.png"
                alt="location"
                width="20px"
                height="25px"
              />
            </b-input-group-prepend>
            <Select2
              class=""
              v-model="_location"
              :options="locations"
              :settings="{ multiple: false, search: false }"
              :search="false"
              placeholder="Select location"
              :preserve-search="false"
              :dropdownCssClass="'custom-dropdown'"
              @open="openSelect2($event)"
              @change="myChangeEvent($event)"
              @select="mySelectEvent($event)"
            />
          </b-input-group>

          <!-- <b-form-select v-model="_location" class="mb-3">
              <b-form-select-option value="zoom"
                >ZOOM ONLINE</b-form-select-option
              >
              <b-form-select-option value="Kimberley Street, London"
                >Kimberley Street, London</b-form-select-option
              >
              <b-form-select-option value="Dublin, Ireland"
                >Dublin, Ireland</b-form-select-option
              >
              <b-form-select-option value="Studio Doom Yoga, London"
                >Studio Doom Yoga, London</b-form-select-option
              >
            </b-form-select>-->
          <!-- </b-input-group
          >  -->
        </b-col>
      </b-row>
      <b-row v-if="_location == 'on_site'">
        <b-col>
          <b-form-group
            label="Address"
            label-for="address"
            :address="address"
            :label-class="{
              'form-label-doomyoga': client_name == 'DY',
              'form-label-mid': client_name == 'MID',
            }"
          >
            <p v-if="invalid_address"
              :class="{
                'error_validation_message_p_dy mx-0': client_name == 'DY',
                error_validation_message_p_mid: client_name == 'MID',
              }">
              Please select address
            </p>
            <GmapAutocomplete
              class="form-control"
              v-bind:class="{
                'form-control-doomyoga': client_name == 'DY',
                'form-control-mid': client_name == 'MID',
              }"
              id="address"
              :options="autocompleteOptions"
              @place_changed="setPlace"
            />
          </b-form-group> </b-col
      ></b-row>
    </b-card-body>
  </b-card>
</template>


<script>
import Select2 from "v-select2-component";
import $ from "jquery";

export default {
  name: "EventLocation",
  props: [
    "location",
    "invalid_location",
    "client_name",
    "locations",
    "invalid_address",
    "address","address_coordinates"
  ],

  components: {
    "vue-select": require("vue-select2"),
    Select2,
  },
  data() {
    return {
      selected: "",
      autocompleteOptions: {
        componentRestrictions: {
          country: ["ie", "us"],
        },
      },
    };
  },
  mounted() {
    // console.log(this.address);
    // console.log(this.address_coordinates);
    $("#address").val(this.address);

  },
  updated(){
    // console.log("update")
    // console.log(this.address);
    // console.log(this.address_coordinates);
    $("#address").val(this.address);
  },
  computed: {
    _location: {
      get() {
        return this.location;
      },
      set(value) {
        this.$emit("update:location", value);
      },
    },
  },
  methods: {
    setAddress(value) {
      // console.log(value)
      this.$emit("update:address", value);
    },
    setAddressCoordinates(value) {
      // console.log(value)
      this.$emit("update:address_coordinates",value);
    },
    openSelect2(e) {
      // console.log("open select 2");
      // console.log(e);
      if (this.client_name == "MID") {
        $(".select2-container--default.select2-container--open").addClass(
          "select2-container-mid"
        );
      } else if (this.client_name == "DY") {
        $(".select2-container--default.select2-container--open").addClass(
          "select2-container-doomyoga"
        );
      }
    },
    myChangeEvent(val) {
      // console.log(val);
     // this.address = "";
      // this.address_coordinates = null;
      this.setAddress("");
      this.setAddressCoordinates(null);
    },
    mySelectEvent({ id, text }) {
      // console.log({ id, text });
      // this.address = "";
      // this.address_coordinates = null;
      this.setAddress("");
      this.setAddressCoordinates(null);
    },
    setPlace(place) {
      // console.log("place");
      // console.log(place);
      // console.log(place.geometry.location.lat());
      // console.log(place.geometry.location.lng());
      // this.address = $("#address").val();
      // this.address_coordinates = {
      //   lat: place.geometry.location.lat(),
      //   lng: place.geometry.location.lng(),
      // };
      this.setAddress($("#address").val());
      this.setAddressCoordinates({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
    },
  },
};
</script>
<style >
</style>


// WEBPACK FOOTER //
// src/components/events/Location.vue